/**
 * La versión del PRODUCTO, que no es la del paquete.
 *
 * ⚠ **No sale de `package.json` a propósito.** Allí `version` es «1.0.0» y describe
 * el paquete npm del frontend, que nadie publica ni instala; «3.0» es el nombre con
 * el que la agencia llama a este sistema —el que sucede al 2.0 en PHP— y se escribe
 * en el blueprint, en la carpeta del repositorio y en el título de cada pantalla.
 * Inyectar la del paquete pondría un «1.0.0» en el acceso que no significa nada para
 * quien lo lee y que contradice al resto del sistema.
 *
 * Se sube a mano, y por eso está sola en su módulo: un número suelto dentro de un
 * componente acaba repetido en tres pantallas con tres valores distintos.
 */
export const VERSION_PRODUCTO = "3.0"

/** El nombre comercial del sistema, tal como se presenta en el acceso. */
export const NOMBRE_PRODUCTO = "SetiecaDesk"

/**
 * El portal de transporte (25/10) es el mismo sistema servido en `transporte.<dominio>`;
 * se presenta como «SetiecaDesk Transporte» para distinguirlo del ERP (pedido del usuario).
 */
export const ES_PORTAL_TRANSPORTE =
  typeof location !== "undefined" && location.hostname.startsWith("transporte.")

export const NOMBRE_PORTAL_TRANSPORTE = `${NOMBRE_PRODUCTO} Transporte`
